import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import api from '../../../../../api';
import LoadingIndicatorFull from '../../../../components/LoadingIndicatorFull';
import { withData } from '../../../../hoc/withData';
import { isFeatureEnabled } from '../../../../services/Features';
import { EMAIL_TEMPLATE_TYPES } from '../../constants/email-templates';
import FeedbackCycleCreate from '../../lazy';
import { loadFeedbackCycle, loadQuestionnaireTemplates } from '../../services/Request';

function FeedbackCycleCopyPage({ cycle, questionnaireTemplates, ...rest }) {
    const { model: backendModel } = cycle;
    const model = { ...backendModel, name: `Copy of ${backendModel.name}`, selfAssessment: false, type: 'LEGACY' };
    return (
        <FeedbackCycleCreate
            mode="copy"
            model={{ ...model, ...rest }}
            questionnaireTemplates={questionnaireTemplates}
        />
    );
}

export default compose(
    setPropTypes({ cycleId: PropTypes.string.isRequired }),
    withData({
        resolve: {
            cycle: ({ cycleId }) => loadFeedbackCycle(cycleId),
            allUsers: () => api.usersMedium.getAll(),
            hrUsers: () => api.usersHR.getAllActiveHrs(true),
            questionnaireTemplates: () =>
                isFeatureEnabled('FEATURE_feedbackQuestionnaireTemplates')
                    ? loadQuestionnaireTemplates()
                    : Promise.resolve([]),
            emailTemplates: ({ cycleId }) =>
                api.emailTemplate.getTemplates(EMAIL_TEMPLATE_TYPES, { feedbackCycleId: cycleId }),
        },
        pendingComponent: () => <LoadingIndicatorFull />,
    })
)(FeedbackCycleCopyPage);
